module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(!_vm.generator_shunt && !_vm.pump_shunt && !_vm.diffs_shunt) ? _c('GeneralSpinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tabs-select-style col-md-12 mb-12"
  }, [_c('ul', {
    staticClass: "nav nav-pills nav-fill"
  }, [(_vm.generator_shunt) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.tab_selected_generator
    },
    on: {
      "click": function($event) {
        _vm.clickNavTabs('generator')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.web_texts.generator) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.pump_shunt) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.tab_selected_pump
    },
    on: {
      "click": function($event) {
        _vm.clickNavTabs('pump')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.web_texts.pump) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.diffs_shunt) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.tab_selected_diffs
    },
    on: {
      "click": function($event) {
        _vm.clickNavTabs('diffs')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.web_texts.diffs) + "\n        ")])]) : _vm._e()])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 mb-12"
  }, [(_vm.tab_selected_generator) ? _c('div', [_c('GeneratorShunting', {
    attrs: {
      "devices": _vm.devices
    }
  })], 1) : (_vm.tab_selected_pump) ? _c('div', [_c('PumpShunting', {
    attrs: {
      "devices": _vm.devices
    }
  })], 1) : (_vm.tab_selected_diffs) ? _c('div', [_c('DiffShunting')], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79c0be86"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Shuntting.vue
// module id = 559
// module chunks = 1